import React from 'react';
import { Helmet } from 'react-helmet';
import googleClickId from './vendor/googleClickId';
import segment from './vendor/segment';
import ambassador from './vendor/ambassador';
import colors from './ui/constants/colors';

const title = 'Bench - Signup';

const link = [
  { rel: 'apple-touch-icon', type: 'image/png', size: '180x180', href: '/apple-touch-icon.png' },
  { rel: 'icon', type: 'image/png', size: '16x16', href: '/favicon-16x16.png' },
  { rel: 'icon', type: 'image/png', size: '32x32', href: '/favicon-32x32.png' },
  { rel: 'manifest', href: '/manifest.json' },
  { rel: 'mask-icon', href: '/safari-pinned-tab.svg', color: colors.oceanGreen },
  { rel: 'shortcut icon', href: '/favicon.ico' },
];

const meta = [
  { name: 'viewport', content: 'width=device-width, initial-scale=1.0, maximum-scale=1.0' },
];

const BenchHelmet = () => (
  <Helmet meta={meta} link={link} title={title}>
    {/* Segment - docs/third-party-vendors/SEGMENT.md */}
    <script>{segment()}</script>
    {/* GCLID - docs/third-party-vendors/GCLID.md */}
    <script>{googleClickId()}</script>
    {/* Ambassador - docs/third-party-vendors/AMBASSADOR.md */}
    <script>{ambassador()}</script>
    <script src="https://mbsy.co/embed/v2/getcookie/bench" />
    {/* Maxmind */}
    <script src="//js.maxmind.com/js/apis/geoip2/v2.1/geoip2.js" async />
  </Helmet>
);

export default BenchHelmet;
